export const TimelineFilterZoomLevel = {
  Quarter: 5,
  Month: 8,
  Week: 10,
  Day: 11,
};
